import {Component, inject, Input} from '@angular/core';
import {LinkWithoutHrefDirective} from '@icz/angular-essentials';
import {ObjectAssociationAlertComponent} from '../object-association-alert/object-association-alert.component';
import {EntityType, ObjectClass} from '|api/commons';
import {TranslateParser, TranslateService} from '@ngx-translate/core';
import {StorageUnitDto} from '|api/document';
import {getSuperclassEntityType} from '|shared';
import {Router} from '@angular/router';
import {ApplicationRoute, createAbsoluteRoute, DocumentsRoute} from '|ui-essl-core';

@Component({
  selector: 'icz-storage-unit-association-alert',
  templateUrl: './storage-unit-association-alert.component.html',
  styleUrl: './storage-unit-association-alert.component.scss',
  imports: [LinkWithoutHrefDirective, ObjectAssociationAlertComponent],
})
export class StorageUnitAssociationAlertComponent {

  private router = inject(Router);
  private translateParser = inject(TranslateParser);
  private translateService = inject(TranslateService);

  @Input({required:true})
  parentEntityType!: EntityType;
  @Input({required:true})
  storageUnit: Nullable<StorageUnitDto>;
  @Input({required:true})
  isStorageUnitUnavailable = false;

  get heading() {
    return this.translateParser.interpolate(
      this.translateService.instant('{{entityType}} je vložen do ukládací jednotky'),
      {
        entityType: this.translateService.instant(`en.entityType.${getSuperclassEntityType(this.parentEntityType)}`),
      }
    )!;
  }

  openStorageUnitDetail(storageUnit: StorageUnitDto) {
    this.router.navigateByUrl(createAbsoluteRoute(ApplicationRoute.DOCUMENTS, DocumentsRoute.STORAGE_UNIT, storageUnit.id));
  }

  protected readonly ObjectClass = ObjectClass;

}
